import api from './api';
export const getAttendanceHolidays = async year => (await api.get('/attendance/holidays', { params: { year } })).data.data;
export const createAttendanceHoliday = async payload => (await api.post('/attendance/holidays', payload)).data.data;
export const updateAttendanceHoliday = async (id, payload) => (await api.patch(`/attendance/holidays/${id}`, payload)).data.data;
